import React, { FC } from 'react';
import CMPImage from 'components/global/image';
interface Props {
  wh?: number;
}
const HerbalismIcon: FC<Props> = ({ wh }) => {
  return (
    <CMPImage
      asset={{
        src: `${process.env.PUBLIC_URL}/images/professions/Herbalism.png`,
        alt: 'Herbalism',
      }}
      width={wh || 64}
      height={wh || 64}
    />
  );
};

export default HerbalismIcon;
